/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EnabledPayer } from './EnabledPayer';
import {
    EnabledPayerFromJSON,
    EnabledPayerFromJSONTyped,
    EnabledPayerToJSON,
} from './EnabledPayer';

/**
 * 
 * @export
 * @interface GetEnabledPayers200Response
 */
export interface GetEnabledPayers200Response {
    /**
     * 
     * @type {Array<EnabledPayer>}
     * @memberof GetEnabledPayers200Response
     */
    data?: Array<EnabledPayer>;
}

/**
 * Check if a given object implements the GetEnabledPayers200Response interface.
 */
export function instanceOfGetEnabledPayers200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetEnabledPayers200ResponseFromJSON(json: any): GetEnabledPayers200Response {
    return GetEnabledPayers200ResponseFromJSONTyped(json, false);
}

export function GetEnabledPayers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEnabledPayers200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(EnabledPayerFromJSON)),
    };
}

export function GetEnabledPayers200ResponseToJSON(value?: GetEnabledPayers200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(EnabledPayerToJSON)),
    };
}

